// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"cleanersTable_tableWrapper__1xM_r","noCleanerMsg":"cleanersTable_noCleanerMsg__1IS1g","selected":"cleanersTable_selected__vxDPn"};